// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"107":"e416f5b5ca26f059","389":"32afd83c1843c23a","462":"1883c37396d5849b","483":"c8ad4fa7b1b47c2b","944":"51ebd84463082a32"}[chunkId] + ".js";
};